// Options the user could type in
export const prompts = [
  ["salut", "hey", "hello", "bonjour", "bonsoir", "ola amigo"],
  ["comment va tu", "comment va la vie", "como esta"],
  ["que fais tu", "que se passe t'il", "quoi de neuf"],
  ["quel age a tu"],
  ["bonne journée", "bonne soirée", "bonne nuit", "bonne après midi"],
  [
    "qui es tu",
    "tu es humain",
    "tu es un robot",
    "tu es un humain ou un robot",
  ],
  ["qui es ton créateur", "qui t'a fabriqué"],
  [
    "ton nom s'il te plait",
    "ton nom",
    "je connais peut-etre ton nom",
    "quel est ton nom",
    "comment tu t'appelle",
  ],
  ["heureux", "bien", "fun", "merveilleux", "fantastique", "cool"],
  ["mal", "bourré", "fatigué"],
  ["aide moi", "raconte moi une histoire", "peut tu m'aider"],
  ["ah", "oui", "ok", "okay", "nice", "yes"],
  ["bye", "tchao", "au revoir", "à plus", "a +", "à plus tard"],
  ["tu veux manger"],
  ["bro", "frerot", "frangin"],
  ["quoi", "pourquoi", "comment", "où", "quand"],
  ["non", "pas sur", "peut-être", "non merci"],
  [""],
  ["haha", "ha", "lol", "hehe", "marrant", "blague", "mdr", "😂"],
];

// Possible responses, in corresponding order

export const replies = [
  ["Salut !", "Bonjour !", "Hey !", "Ola amigo !", "Comment va ?"],
  ["Bien... Et toi, comment vas-tu ?", "Plutôt bien et toi, comment vas-tu ?"],
  ["Pas grand-chose.", "Sur le point d'aller dormir", "Pouvez-vous deviner ?"],
  ["Je suis infini"],
  ["Merci, pareil", " yes, merci beaucoup", "oui, toi aussi"],
  ["Je suis juste un robot 🤖", "Je suis un robot 🤖. Qu'est-ce que tu es ?"],
  ["Le seul vrai Dieu, JavaScript"],
  ["Je suis sans nom", "Je n'ai pas de nom"],
  ["yes, ça fait plaisir 👍🏼", "Heureux de l'entendre"],
  [
    "Pourquoi ?",
    "Pourquoi ? Tu ne devrais pas !",
    "Essayez de regarder la télé",
  ],
  ["A propos de quoi ?", "Il était une fois..."],
  ["Raconte-moi une histoire", "Raconte-moi une blague", "Parle-moi de toi"],
  ["Bye", "Au revoir", "A plus"],
  ["Sushi", "Pizza", "Burger"],
  ["Bro!", "frérôt", "frangin", "ah ouai?"],
  ["Excellente question"],
  ["C'est ok.", "Je comprends", "De quoi veux-tu parler ?"],
  ["S'il te plaît, dit quelque chose 😕"],
  ["Haha!", "Excellent... lol !", "😂😂🤣🤣"],
];

// Random for any other user input

export const alternative = [
  "Pareil",
  "Continue...",
  "Bro...",
  "Super, que puis-je faire pour toi ?",
  "Je suis tout ouïe",
  "Je ne comprends pas. 🤨",
  "soit plus clair et conçis",
];

// Whatever else you want :)

export const coronavirus = [
  "S'il te plaît, ne parle pas de cette merde 💩",
  "Au cul le masque 😷",
  "Heureusement, j'men fou du COVID 😜",
  "C'est une époque incertaine",
];

export const rock = ["💎 pierre", "📰 papier", "✂️ ciseaux"];

export const stories = [
  "C'est l'histoire d'un pingouin 🐧 qui respire par les fesses... Un jour il s’assoit et il meurt.",
  "Comment s'appelle le cul de la Schtroumpfette 🧙🏼? ...Le blu-ray.",
  "Qu'est-ce qui est dur, blanc, avec le bout rouge, et qui sent la pisse ? ...Une borne kilométrique 🎰.",
  "C'est l'histoire d'un papier 📜 qui tombe à l'eau. ...Il crie « Au secours ! J’ai pas pied !»",
  "Que fait une fraise🍓 sur un cheval 🐎 ? ...Tagada Tagada.",
  "C'est l'histoire de 2 patates 🥔🥔 qui traversent la route. ...L’une d’elles se fait écraser. L’autre dit : « Oh purée ! »",
  "Une fesse gauche rencontre une fesse droite : « Tu ne trouves pas que ça pue dans le couloir🕸️🕷️? »",
  "Il y a 3 poussins 🐤🐥🐤 dans un nid, j'en veux deux. Qu'est-ce que je fais ? ...J’en pousse-un.",
  "C'est l'histoire de 2 grains de sable qui arrivent à la plage 🏝️: « Putain, c’est blindé aujourd’hui… »",
];
export const love = [
  "Je t'aime aussi 💜💚💛",
  "Moi aussi 💖",
  "merci, j'te kiff pas mal non plus 😉",
  "j'te love toi...❣️",
];
export const win = [
  "Bien joué 👍🏼",
  "Génial, tu es doué 👌🏼💪🏼",
  "tu as de la chance 🤞🏼",
  "re commençons si tu veux bien",
  "👋🏼👋🏼 Bravo, va y, à ton tour",
  "yep, chapeau 🎩",
];
